import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
// import "../../../6729.css";


import image1 from "../../../images/service-fluid/4212/4212_1front.webp"
import image2 from "../../../images/service-fluid/4212/4212_1back.webp"
import image3 from "../../../images/service-fluid/4212/4212_5front.webp"
import image4 from "../../../images/service-fluid/4212/4212_5back.webp"


const images = [
    { src: image1, alt: "Front" },
     { src: image2, alt: "Back 5L" },
    { src: image3, alt: "Back" },
    { src: image4, alt: "Front 5L" },
   
];

const packageSlides = [
    { images: [image1, image2] },
    { images: [image3, image4] },
];

const TDS_URL = "https://www.fanfaro.de/create-pdf/145";

const SDS_FILES = [
  { code: "BE", url: "https://sct-b2b.com/out/msds/sdFF4212_-_FANFARO 4212 Coolant G12+_(BE).pdf" },
  { code: "BG", url: "https://sct-b2b.com/out/msds/sdFF4212_-_FANFARO 4212 Coolant G12+_(BG).pdf" },
  { code: "CZ", url: "https://sct-b2b.com/out/msds/sdFF4212_-_FANFARO 4212 Coolant G12+_(CZ).pdf" },
  { code: "DE", url: "https://sct-b2b.com/out/msds/sdFF4212_-_FANFARO 4212 Coolant G12+_(DE).pdf" },
  { code: "DK", url: "https://sct-b2b.com/out/msds/sdFF4212_-_FANFARO 4212 Coolant G12+_(DK).pdf" },
  { code: "EE", url: "https://sct-b2b.com/out/msds/sdFF4212_-_FANFARO 4212 Coolant G12+_(EE).pdf" },
  { code: "ES", url: "https://sct-b2b.com/out/msds/sdFF4212_-_FANFARO 4212 Coolant G12+_(ES).pdf" },
  { code: "FI", url: "https://sct-b2b.com/out/msds/sdFF4212_-_FANFARO 4212 Coolant G12+_(FI).pdf" },
  { code: "FR", url: "https://sct-b2b.com/out/msds/sdFF4212_-_FANFARO 4212 Coolant G12+_(FR).pdf" },
  { code: "GR", url: "https://sct-b2b.com/out/msds/sdFF4212_-_FANFARO 4212 Coolant G12+_(GR).pdf" },
  { code: "HR", url: "https://sct-b2b.com/out/msds/sdFF4212_-_FANFARO 4212 Coolant G12+_(HR).pdf" },
  { code: "HU", url: "https://sct-b2b.com/out/msds/sdFF4212_-_FANFARO 4212 Coolant G12+_(HU).pdf" },
  { code: "IE (EN)", url: "https://sct-b2b.com/out/msds/sdFF4212_-_FANFARO 4212 Coolant G12+_(IE).pdf" },
  { code: "IT", url: "https://sct-b2b.com/out/msds/sdFF4212_-_FANFARO 4212 Coolant G12+_(IT).pdf" },
  { code: "LT", url: "https://sct-b2b.com/out/msds/sdFF4212_-_FANFARO 4212 Coolant G12+_(LT).pdf" },
  { code: "LV", url: "https://sct-b2b.com/out/msds/sdFF4212_-_FANFARO 4212 Coolant G12+_(LV).pdf" },
  { code: "NO", url: "https://sct-b2b.com/out/msds/sdFF4212_-_FANFARO 4212 Coolant G12+_(NO).pdf" },
  { code: "PL", url: "https://sct-b2b.com/out/msds/sdFF4212_-_FANFARO 4212 Coolant G12+_(PL).pdf" },
  { code: "PT", url: "https://sct-b2b.com/out/msds/sdFF4212_-_FANFARO 4212 Coolant G12+_(PT).pdf" },
  { code: "RO", url: "https://sct-b2b.com/out/msds/sdFF4212_-_FANFARO 4212 Coolant G12+_(RO).pdf" },
  { code: "RU", url: "https://sct-b2b.com/out/msds/sdFF4212_-_FANFARO 4212 Coolant G12+_(RU).pdf" },
  { code: "SE", url: "https://sct-b2b.com/out/msds/sdFF4212_-_FANFARO 4212 Coolant G12+_(SE).pdf" },
  { code: "SI", url: "https://sct-b2b.com/out/msds/sdFF4212_-_FANFARO 4212 Coolant G12+_(SI).pdf" },
  { code: "SK", url: "https://sct-b2b.com/out/msds/sdFF4212_-_FANFARO 4212 Coolant G12+_(SK).pdf" }
];

export default function ImageWithContent() {

    const [currentIndex, setCurrentIndex] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [showSDS, setShowSDS] = useState(false);

    const [packageIndex, setPackageIndex] = useState(0);
    const [imageIndex, setImageIndex] = useState(0);

    const slideInterval = useRef(null);
    const slideDuration = 4000;

    useEffect(() => {
        startSlideTimer();
        return () => clearInterval(slideInterval.current);
    }, []);

    const startSlideTimer = () => {
        slideInterval.current = setInterval(() => {
            setCurrentIndex((prev) => (prev + 1) % images.length);
        }, slideDuration);
    };

    const goToSlide = (index) => {
        setCurrentIndex(index);
        clearInterval(slideInterval.current);
        startSlideTimer();
    };

    const nextImage = () => {
        const total = packageSlides[packageIndex].images.length;
        setImageIndex((prev) => (prev + 1) % total);
    };

    const prevImage = () => {
        const total = packageSlides[packageIndex].images.length;
        setImageIndex((prev) => (prev === 0 ? total - 1 : prev - 1));
    };

    return (
       <>
         <div
            style={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "flex-start",
                justifyContent: "center",
                gap: "32px",
                padding: "24px",
                fontFamily: "Arial",
            }}
        >

            {/* LEFT IMAGE CAROUSEL */}
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>

        {/* IMAGE CAROUSEL */}
        <div
          style={{
            position: "relative",
            width: "300px",
            height: "400px",
            borderRadius: "8px",
            overflow: "hidden",
          }}
        >
          {images.map((img, index) => (
            <img
              key={index}
              src={img.src}
              alt={img.alt}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                position: index === currentIndex ? "relative" : "absolute",
                opacity: index === currentIndex ? 1 : 0,
                transition: "opacity 1s",
              }}
            />
          ))}
        </div>
        <p
          style={{
            // marginTop: "15px",
            fontSize: "14px",
            color: "#0c0c0c",
            textAlign: "justify",
            lineHeight: "1.6",
            width:"250px",
            fontSize:"12px"
          }}
        >
          Attention! The packaging is illustrative and may differ from its actual appearance. For the latest list of specifications, see the text section.
        </p>


        
        {/* Amazon Button (external link) */}
        <a
          href="https://kytecarparts.com/products/fanfaro-4212-g12-ready-to-use-antifreeze-oat-organic-carboxylated-coolant-imported-from-germany?"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none" }}
        >
          <button
            style={{
              width: "150px",
              padding: "12px",
              backgroundColor: "#0d4d33",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              fontSize: "16px",
              cursor: "pointer",
            }}
          >
            Buy Now
          </button>
        </a>

      </div>

            {/* RIGHT CONTENT */}
            <div style={{ paddingLeft: "30px", maxWidth: "850px" }}>
                <h2>FANFARO Coolant G12+ 4212</h2>

                <p>

                  A carboxylated (organic – OAT Organic Acid Technology) ready-for-use solution, designed for a year-round use in any modern cooling systems for which the use of ethylene-glycol-based antifreeze is recommended. It ensures a reliable protection of any cooling system.
                    </p>

                <p><strong>Product properties:</strong></p>

                <ul style={{ paddingLeft: "20px" }}>
  <li>It ensures a reliable protection of metals and alloys (brass, copper, alloy-treated steel, cast iron, aluminium) from all forms of corrosion, as well as prevents a high-temperature corrosion of aluminium surfaces of modern engines;</li>
  <li>It has an exceptional thermal stability. It protects from deposit formation;</li>
  <li>It has excellent heat conductivity properties and a resistance to foam formation;</li>
  <li>It is neutral to inserts and hoses, compatible with all types of rubber and plastic components of a cooling system;</li>
  <li>It has an excellent resistance to hard water and very low corrosion inhibitor depletion rates;</li>
  <li>The highly effective carboxylated additive package (OAT) ensures an exceptional stability of service qualities of the antifreeze throughout the entire service life;</li>
  <li>It does not contain silicates, nitrates, phosphates and amines (the NAP free technology);</li>
  <li>It has an extended service life in cooling systems: of passenger cars – up to 250 thousand km; of commercial vehicles – up to 500 thousand km; of stationary engines – up to 6 years.</li>
                           </ul> <br />

                <p>
                    It is recommended for engines requiring enhanced heat dissipation: highly accelerated engines, engines with a turbocharger and cooling systems of modern commercial vehicles.<br/>

Colour: red.<br/>

Service life: no less than 5 years.<br/>
Comply with the manufacturer’s instructions provided in the user’s manual!  </p>


                <p style={{ color: "#4CAF50", fontWeight: "bold" }}>
                    CORRESPONDS WITH REQUIREMENTS / SPECIFICATIONS / PRODUCTS:
                </p>

                {/* SPECIFICATIONS */}
                <div style={{ display: "flex", gap: "40px", flexWrap: "wrap" }}>
                    <div>
                        <b>Specifications</b>
                        {/* <ul style={{ paddingLeft: "20px" }}>
                            <ul style={{ paddingLeft: "20px" }}>
                                <li>SAE J1703</li>
                                <li>SAE J1704</li>
                                <li>ISO 4925 Class 3</li>
                                <li>ISO 4925 Class 4</li>
                                <li>FMVSS 116 DOT 3</li>
                                <li>FMVSS 116 DOT 4</li>
                                <li>JIS K2233</li>
                            </ul>
                        </ul> */}
                    </div>


                    <div>
                        <b>Recommendation</b>
                       
<ul style={{ paddingLeft: "20px" }}>
  <li>SAE J1034</li>
  <li>AFNOR FRANCE NF R15-601 (except for RA)</li>
  <li>ASTM USA D3306</li>
  <li>ASTM USA D4656</li>
  <li>ASTM USA D4985</li>
  <li>ASTM USA D6210</li>
  <li>FVV GERMANY Heft R443</li>
  <li>KSM SOUTH KOREA 2142</li>
  <li>MIL BELGIUM BT-PS-606-A</li>
  <li>MIL FRANCE DCSEA 615/C</li>
  <li>MIL ITALY E/L-1415b</li>
  <li>MIL SWEDEN FSD 8704</li>
  <li>NATO S-759</li>
  <li>OENORM AUSTRIA V5123</li>
  <li>UNE SPAIN 26-361-88/1</li>
  <li>VOLKSWAGEN TL 774 D</li>
  <li>VOLKSWAGEN TL 774 F</li>
  <li>BERGEN ENGINES 2.13.01</li>
  <li>BMW GS 94000</li>
  <li>BRB BR 637</li>
  <li>CASE NEW HOLLAND MAT 3624</li>
  <li>CATERPILLAR MAK A4.05.09.01</li>
  <li>CUMMINS CES 14439</li>
  <li>CUMMINS CES 14603</li>
  <li>CUMMINS IS series N14</li>
  <li>DACIA 41-01-001</li>
  <li>DACIA 41-01-001-T</li>
  <li>DAF 74002</li>
  <li>DETROIT DIESEL 93K217</li>
  <li>FORD WSS-M97B44-D</li>
  <li>JAGUAR CMR 8229</li>
  <li>JAGUAR STJLR.651.5003</li>
  <li>JENBACHER TA 1000-0201</li>
  <li>JOHN DEERE JDM H5</li>
  <li>KOMATSU 07.892 (2009)</li>
  <li>LAND ROVER STJLR.651.5003</li>
  <li>LEYLAND TRUCKS DW03245403</li>
  <li>LIEBHERR MD1-36-130</li>
  <li>MACK 014 GS 17009</li>
  <li>MAN 324 SNF</li>
  <li>MAN B W DIESEL AG D36 5600</li>
  <li>MAZDA MEZ MN 121 D</li>
  <li>MB 325.3</li>
  <li>MINI GS 94000</li>
  <li>MTU MTL 5048</li>
  <li>MWM 0199-99-2091/11</li>
  <li>BSI GB BS 6580:2010</li>
  <li>JASO M325</li>
  <li>MITSUBISHI MHI</li>
</ul>

                    </div>

                    <div>
                        <b>PACKAGES:</b>
                        <ul style={{ paddingLeft: "20px" }}>

                            <li>
                                <span
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                        setPackageIndex(0);
                                        setImageIndex(0);
                                        setShowModal(true);
                                    }}
                                >
                          
1L (FF4212-1)
                                </span>
                            </li>

                            <li>
                                <span
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                        setPackageIndex(1);
                                        setImageIndex(0);
                                        setShowModal(true);
                                    }}
                                >
                                  5L (FF4212-5)
                                </span>
                            </li>

   {/*                          <li>
                                <span
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                        setPackageIndex(2);
                                        setImageIndex(0);
                                        setShowModal(true);
                                    }}
                                >
                                    60L (FF6208-DR)
                                </span>
                            </li>

                            <li>
                                <span
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                        setPackageIndex(3);
                                        setImageIndex(0);
                                        setShowModal(true);
                                    }}
                                >
                                    208L (FF6208-IBC)
                                </span>
                            </li> */}

                        </ul>
                    </div>
                    <div>
                        <b>SDS & TDS</b>
                        <ul style={{ paddingLeft: "20px" }}>

                            <li>
                                
                                <a
                                    href=""
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setShowSDS(true);
                                    }}
                                    style={{ textDecoration: "none", cursor: "pointer" }}
                                >
                                    📄 SDS
                                </a>
                            </li>

                            <li>
                                <a
                                    href="https://www.fanfaro.de/create-pdf/145"
                                    target="_blank"
                                    style={{ textDecoration: "none" }}>
                                    🖨️ TDS
                                </a>
                            </li>

                        </ul>
                    </div>

                </div>



            </div>

            {/* MODAL */}
            {showModal && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        background: "rgba(0,0,0,0.6)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 999,
                    }}
                >
                    <div
                        style={{
                            background: "#fff",
                            padding: "20px",
                            width: "500px",
                            borderRadius: "8px",
                            position: "relative",
                        }}
                    >

                        <span
                            onClick={() => setShowModal(false)}
                            style={{
                                position: "absolute",
                                right: "15px",
                                top: "10px",
                                cursor: "pointer",
                                fontSize: "22px",
                            }}
                        >
                            ✕
                        </span>

                        <img
                            src={packageSlides[packageIndex].images[imageIndex]}
                            alt="package"
                            style={{
                                width: "100%",
                                maxHeight: "450px",
                                objectFit: "contain",
                            }}
                        />

                        <div style={{ textAlign: "center", marginTop: "20px" }}>

                            <button onClick={prevImage}>◀</button>

                            <span style={{ margin: "0 15px" }}>
                                {imageIndex + 1} of {packageSlides[packageIndex].images.length}
                            </span>

                            <button onClick={nextImage}>▶</button>

                        </div>

                    </div>
                </div>
            )}

            {showSDS && (
                <div className="sds-overlay" onClick={() => setShowSDS(false)}>
                    <div className="sds-modal" onClick={(e) => e.stopPropagation()}>
                        {/* Close Icon */}
                        <button
                            className="sds-close-icon"
                            onClick={() => setShowSDS(false)}
                            aria-label="Close SDS"
                        >
                            ×
                        </button>

                        <h3>Back 4L FANFARO S-4T+ 20W-50</h3>

                        <div className="sds-grid">
                            {SDS_FILES.map((file) => (
                                <a
                                    key={file.code}
                                    href={file.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {file.code}
                                </a>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </div>

        <a
        href="https://wa.me/7204731100?text=Hello%20I%20need%20details"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
      >
        <img
          src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
          alt="WhatsApp"
        />
      </a>
       </>
    );
}